import BookingData from "@/classes/BookingData"
import Discount from "@/model/Discount"

import { QuoteState } from "@requests"

const processDiscounts = (bookingData: BookingData, sourceObj: QuoteState) => {
    // promocode
    if (sourceObj?.promocode) {
        const promocodeDiscount = new Discount("Promocode", sourceObj?.promocode) // TEMPORARY hardcoded field name
        bookingData.discounts.push(promocodeDiscount)
    }
}

export default processDiscounts